"use client";

import { LegacyRef, useEffect, useState } from "react";
import useIntersectionObserver from "libs/hooks/src/lib/useIntersectionObserver";
import { ROUTE_SIGN_UP_FLOW } from "apps/website/constants/routes";

import SectionStickyCTA from "../../section/SectionStickyCTA/SectionStickyCTA";

export interface ILandingPageStickyProps {
  linkTo?: string;
  ctaText?: string;
}

export default function LandingPageSticky({ linkTo = `${ROUTE_SIGN_UP_FLOW}?discount_code=TRY20`, ctaText = "TRY NOW WITH 20% OFF" }: Readonly<ILandingPageStickyProps>) {

  const [ containerRef, isVisible ] = useIntersectionObserver();
  const [ scrollStickyCtaScrollDepthHit, setScrollStickyCtaScrollDepthHit ] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setScrollStickyCtaScrollDepthHit(true);
    }
  }, [ isVisible ]);

  return (
    <div ref={ containerRef as LegacyRef<HTMLDivElement> }>
      <SectionStickyCTA
        cta={ {
          id: "start-trial-cta",
          name: ctaText,
          to: linkTo,
        } }
        disabled={ !scrollStickyCtaScrollDepthHit }
        hideIfDisabled
        text='"Our very fussy cats absolutely love this food"'
      />
    </div>
  );
}
